module.exports = __webpack_public_path__ + "img/36.b013d627.png";